import { render, staticRenderFns } from "./AcceptInvite.vue?vue&type=template&id=0375f8b1&"
import script from "./AcceptInvite.vue?vue&type=script&lang=js&"
export * from "./AcceptInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AcceptInvite.vue"
export default component.exports